import { isArray } from 'lodash';

export const getArrayDefault = <T>(array: T) => {
  if (isArray(array)) return array;
  return [];
};
export const sortObjectsArrayByKey = <T>(array: T[], key: keyof T) => {
  if (!isArray(array)) return [];
  return array.sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
};

export const swapElements = (array: Array<ExpectedAny>, index1: number, index2: number) => {
  const newArray = [...array];

  [newArray[index1], newArray[index2]] = [newArray[index2], newArray[index1]];
  return newArray;
};
